import React from "react";

const RetirementSummary = ({ payload, activeTabName }) => {
  const retirementSpending = [
    "Net Annual Pre-Retirement Budget",
  ];

  const retirementIncome = [
    "Total Annual Retirement Income",
  ];

  const getSum = (keys) =>
    keys.reduce((acc, key) => {
      const val = payload[key] && parseFloat(payload[key]);
      return acc + (!isNaN(val) ? val : 0);
    }, 0);

  const formatCurrency = (amount) => {
    const num = Number(amount) || 0; // Ensure it's always a number
    return "$" + num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };


  const amountRetirementSpending =
    Number(getSum(retirementSpending)) || 0;
  const amountRetirementIncome =
    Number(getSum(retirementIncome)) || 0;

  const potentialSaving =
    amountRetirementIncome - amountRetirementSpending;

  return (
    <div>
      {/*activeTabName &&
        [
          "RETIREMENT ANNUAL SPENDING (TODAY'S DOLLARS)",
          "RETIREMENT ANNUAL INCOME (TODAY'S DOLLARS)",
          "ASSIGN ASSET",
          "STRATEGY ANALYSIS",
        ].includes(activeTabName) && (
          <div className="descriptionDisplay">
            <div>
              Projected Spending: {formatCurrency(amountRetirementSpending)}
            </div>
            <div>
              Fixed Income:{" "}
              {formatCurrency(amountRetirementIncome)}
            </div>
            <div>
              Potential Gap:{" "}
              {formatCurrency(potentialSaving)}
            </div>
          </div>
        ) */}

    </div>
  );
};

export default RetirementSummary;
